import React from 'react'
import { Element } from 'react-scroll'

import './CallToAction.scss'
import ButtonLink from '../ButtonLink/ButtonLink'

const CallToAction = () => (
  <Element name="listen" id="listen" className="page-section">
    <div className="call-to-action-container">
      <div className="youtube-container">
        <p className="youtube-title">Watch the music video for "This is Wild"</p>
        <iframe
          title="This is Wild music video"
          src="https://www.youtube.com/embed/XgTQQTmU0V8"
          width="560"
          height="315"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
      <div className="iframe-container">
        <iframe
          title="play rope and ladder music"
          src="https://open.spotify.com/embed/album/0JbsHnSMqsYam72WyoHc0L"
          width="400"
          height="360"
          frameBorder="0"
          allowTransparency
          allow="encrypted-media"
        />
        <div className="link-container">
          <ButtonLink
            suppressNewPage
            filled
            link="/#store"
            label="official store"
            icon="fa fa-shopping-cart"
          />
          <ButtonLink
            filled
            link="https://open.spotify.com/artist/4DzHgjIaJBDJwQnZTXLnXC?si=Gy4ZUwLkRyejESVCq7aiaw"
            label="spotify"
            icon="fab fa-spotify"
          />
          <ButtonLink
            filled
            link="https://www.youtube.com/@ropeandladder"
            label="youtube"
            icon="fab fa-youtube-square"
          />
          <ButtonLink
            filled
            link="https://ropeandladder.bandcamp.com/"
            label="bandcamp"
            icon="fab fa-bandcamp"
          />
          <ButtonLink
            filled
            link="https://music.apple.com/ua/artist/rope-and-ladder/1485884225"
            label="apple music"
            icon="fab fa-apple"
          />

          <ButtonLink
            filled
            link="https://www.amazon.com/Rope-Ladder/dp/B083QQ5T26"
            label="amazon"
            icon="fab fa-amazon"
          />
        </div>
      </div>
    </div>
  </Element>
)

export default CallToAction
